import React, { useEffect, useState } from 'react';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function FooterSection() {
  const [openModal, setOpenModal] = useState<ModalType>(null);
  useEffect(() => {
    if (openModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [openModal]);
  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      setOpenModal(null);
    }
  };
  return <>
      {/* Footer Bar */}
      <footer className="w-full py-6 px-4" style={{
      background: 'linear-gradient(160deg, #1A0E09 0%, #2C1810 50%, #1A0E09 100%)',
      borderTop: '1px solid rgba(212, 168, 83, 0.15)'
    }} data-id="element-13">
        <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6" data-id="element-14">
          <p className="font-lato text-xs text-center" style={{
          color: 'rgba(253, 248, 240, 0.35)'
        }} data-id="element-15">
            © 2024 Exosome Express · Producto digital · Todos los derechos
            reservados
          </p>
          <div className="flex items-center gap-1" style={{
          color: 'rgba(253, 248, 240, 0.2)'
        }} data-id="element-16">
            <span className="hidden sm:inline text-xs" data-id="element-17">·</span>
          </div>
          <div className="flex items-center gap-4" data-id="element-18">
            <button onClick={() => setOpenModal('privacy')} className="font-lato text-xs transition-colors duration-200 hover:underline underline-offset-2" style={{
            color: 'rgba(212, 168, 83, 0.6)'
          }} onMouseEnter={e => e.currentTarget.style.color = 'rgba(212, 168, 83, 1)'} onMouseLeave={e => e.currentTarget.style.color = 'rgba(212, 168, 83, 0.6)'} data-id="element-19">
              Política de Privacidad
            </button>
            <span className="text-xs" style={{
            color: 'rgba(253, 248, 240, 0.2)'
          }} data-id="element-20">
              ·
            </span>
            <button onClick={() => setOpenModal('terms')} className="font-lato text-xs transition-colors duration-200 hover:underline underline-offset-2" style={{
            color: 'rgba(212, 168, 83, 0.6)'
          }} onMouseEnter={e => e.currentTarget.style.color = 'rgba(212, 168, 83, 1)'} onMouseLeave={e => e.currentTarget.style.color = 'rgba(212, 168, 83, 0.6)'} data-id="element-21">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Modal Backdrop */}
      {openModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{
      background: 'rgba(20, 10, 6, 0.85)',
      backdropFilter: 'blur(6px)',
      animation: 'fadeIn 0.2s ease-out'
    }} onClick={handleBackdropClick} data-id="element-22">
          <div className="relative w-full max-w-2xl max-h-[85vh] rounded-2xl overflow-hidden flex flex-col" style={{
        background: 'linear-gradient(160deg, #2C1810 0%, #3D2015 60%, #2C1810 100%)',
        border: '1px solid rgba(212, 168, 83, 0.25)',
        boxShadow: '0 25px 60px rgba(0,0,0,0.5), 0 0 40px rgba(212, 168, 83, 0.08)',
        animation: 'slideUp 0.25s ease-out'
      }} data-id="element-23">
            {/* Modal Header */}
            <div className="flex items-center justify-between px-8 py-5 flex-shrink-0" style={{
          borderBottom: '1px solid rgba(212, 168, 83, 0.15)'
        }} data-id="element-24">
              <div className="flex items-center gap-3" data-id="element-25">
                <div className="w-8 h-1 rounded-full" style={{
              background: 'var(--color-gold)'
            }} data-id="element-26" />
                <h2 className="font-playfair text-xl font-bold" style={{
              color: 'var(--color-cream)'
            }} data-id="element-27">
                  {openModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h2>
              </div>
              <button onClick={() => setOpenModal(null)} className="w-8 h-8 rounded-full flex items-center justify-center transition-all duration-200" style={{
            background: 'rgba(253, 248, 240, 0.06)',
            color: 'rgba(253, 248, 240, 0.5)',
            border: '1px solid rgba(253, 248, 240, 0.1)'
          }} onMouseEnter={e => {
            e.currentTarget.style.background = 'rgba(212, 168, 83, 0.15)';
            e.currentTarget.style.color = 'rgba(212, 168, 83, 1)';
          }} onMouseLeave={e => {
            e.currentTarget.style.background = 'rgba(253, 248, 240, 0.06)';
            e.currentTarget.style.color = 'rgba(253, 248, 240, 0.5)';
          }} aria-label="Cerrar" data-id="element-28">
                <XIcon size={14} data-id="element-29" />
              </button>
            </div>

            {/* Modal Content */}
            <div className="overflow-y-auto px-8 py-6 flex-1" style={{
          scrollbarWidth: 'thin',
          scrollbarColor: 'rgba(212,168,83,0.3) transparent'
        }} data-id="element-30">
              {openModal === 'privacy' ? <PrivacyContent data-id="element-31" /> : <TermsContent data-id="element-32" />}
            </div>

            {/* Modal Footer */}
            <div className="px-8 py-4 flex-shrink-0 flex justify-end" style={{
          borderTop: '1px solid rgba(212, 168, 83, 0.1)'
        }} data-id="element-33">
              <button onClick={() => setOpenModal(null)} className="font-lato font-bold text-sm px-6 py-2.5 rounded-full transition-all duration-200 hover:brightness-110" style={{
            background: 'linear-gradient(135deg, #D4A853, #E8C47A)',
            color: 'var(--color-dark)'
          }} data-id="element-34">
                Entendido
              </button>
            </div>
          </div>
        </div>}

      <style data-id="element-35">{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(16px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </>;
}
function PrivacyContent() {
  return <div className="space-y-6" data-id="element-36">
      <p className="font-lato text-sm leading-relaxed" style={{
      color: 'rgba(253,248,240,0.5)'
    }} data-id="element-37">
        Última actualización: enero 2024
      </p>

      <Section title="1. Responsable del Tratamiento" data-id="element-38">
        <p data-id="element-39">
          Exosome Express es el responsable del tratamiento de los datos
          personales que nos facilites a través de esta página web y del proceso
          de compra del producto digital «Rutina Antiarrugas 40+ en 7 Días».
        </p>
      </Section>

      <Section title="2. Datos que Recopilamos" data-id="element-40">
        <p data-id="element-41">
          Únicamente recopilamos los datos estrictamente necesarios para
          procesar tu compra y entregarte el producto digital:
        </p>
        <ul className="mt-3 space-y-1.5 list-none" data-id="element-42">
          <Li data-id="element-43">Dirección de correo electrónico (para envío del producto)</Li>
          <Li data-id="element-44">
            Datos de pago (gestionados de forma segura por el procesador de
            pagos; no almacenamos datos de tarjeta)
          </Li>
        </ul>
        <p className="mt-3" data-id="element-45">
          No recopilamos nombre, dirección postal ni ningún otro dato personal
          adicional.
        </p>
      </Section>

      <Section title="3. Finalidad del Tratamiento" data-id="element-46">
        <ul className="space-y-1.5 list-none" data-id="element-47">
          <Li data-id="element-48">Procesar y completar tu compra del producto digital</Li>
          <Li data-id="element-49">Enviarte el acceso al PDF y materiales incluidos</Li>
          <Li data-id="element-50">Cumplir con las obligaciones legales aplicables</Li>
        </ul>
      </Section>

      <Section title="4. Base Legal" data-id="element-51">
        <p data-id="element-52">
          El tratamiento de tus datos se basa en la ejecución del contrato de
          compraventa (Art. 6.1.b RGPD) y, en su caso, en el cumplimiento de
          obligaciones legales (Art. 6.1.c RGPD).
        </p>
      </Section>

      <Section title="5. Conservación de Datos" data-id="element-53">
        <p data-id="element-54">
          Conservamos tu correo electrónico durante el tiempo necesario para la
          entrega del producto y, posteriormente, durante los plazos legalmente
          exigidos en materia fiscal y mercantil (generalmente 5 años).
        </p>
      </Section>

      <Section title="6. Tus Derechos" data-id="element-55">
        <p data-id="element-56">
          Tienes derecho a acceder, rectificar, suprimir, limitar u oponerte al
          tratamiento de tus datos, así como a la portabilidad de los mismos,
          conforme al RGPD y la LOPDGDD. Puedes ejercer estos derechos enviando
          un correo a la dirección indicada en el proceso de compra.
        </p>
      </Section>

      <Section title="7. Cookies" data-id="element-57">
        <p data-id="element-58">
          Esta página puede utilizar cookies técnicas estrictamente necesarias
          para su funcionamiento. No utilizamos cookies de seguimiento ni
          publicidad de terceros sin tu consentimiento previo.
        </p>
      </Section>

      <Section title="8. Seguridad" data-id="element-59">
        <p data-id="element-60">
          Aplicamos medidas técnicas y organizativas adecuadas para proteger tus
          datos frente a accesos no autorizados, pérdida o destrucción
          accidental.
        </p>
      </Section>
    </div>;
}
function TermsContent() {
  return <div className="space-y-6" data-id="element-61">
      <p className="font-lato text-sm leading-relaxed" style={{
      color: 'rgba(253,248,240,0.5)'
    }} data-id="element-62">
        Última actualización: enero 2024
      </p>

      <Section title="1. Objeto" data-id="element-63">
        <p data-id="element-64">
          Los presentes Términos y Condiciones regulan la compra y uso del
          producto digital «Rutina Antiarrugas 40+ en 7 Días — Exosome Express»
          (en adelante, «el Producto»). Al completar la compra, aceptas
          íntegramente estas condiciones.
        </p>
      </Section>

      <Section title="2. Naturaleza del Producto" data-id="element-65">
        <p data-id="element-66">
          El Producto es un bien digital descargable en formato PDF que incluye
          un protocolo de cuidado facial, checklists y hojas de trabajo. No
          constituye consejo médico, diagnóstico ni tratamiento. Consulta a un
          profesional sanitario ante cualquier duda sobre tu piel.
        </p>
      </Section>

      <Section title="3. Precio y Pago" data-id="element-67">
        <p data-id="element-68">
          El precio del Producto es de{' '}
          <strong style={{
          color: 'var(--color-gold)'
        }} data-id="element-69">
            €6,39
          </strong>{' '}
          (IVA incluido si aplica). El pago se realiza en un único cargo sin
          suscripciones ni cargos recurrentes. El acceso al Producto es de por
          vida (lifetime).
        </p>
      </Section>

      <Section title="4. Entrega" data-id="element-70">
        <p data-id="element-71">
          Tras confirmar el pago, recibirás el enlace de descarga en la
          dirección de correo electrónico proporcionada. La entrega es inmediata
          o en un plazo máximo de 24 horas. Si no recibes el correo, revisa tu
          carpeta de spam.
        </p>
      </Section>

      <Section title="5. Política de Reembolso" data-id="element-72">
        <p data-id="element-73">
          Dado que se trata de un producto digital con acceso inmediato, de
          conformidad con el Art. 103.m) del Real Decreto Legislativo 1/2007, el
          derecho de desistimiento no es aplicable una vez iniciada la descarga
          o el acceso al contenido digital. No obstante, si experimentas un
          problema técnico que impida el acceso al Producto, nos comprometemos a
          resolverlo o a emitir un reembolso completo.
        </p>
      </Section>

      <Section title="6. Propiedad Intelectual" data-id="element-74">
        <p data-id="element-75">
          Todos los contenidos del Producto (textos, imágenes, diseño,
          protocolos) son propiedad exclusiva de Exosome Express y están
          protegidos por la legislación de propiedad intelectual. Queda
          expresamente prohibida su reproducción, distribución, venta o cesión
          total o parcial sin autorización escrita.
        </p>
      </Section>

      <Section title="7. Uso Personal" data-id="element-76">
        <p data-id="element-77">
          La licencia de uso concedida es personal, intransferible y para uso
          privado exclusivamente. No está permitido compartir, revender ni
          distribuir el Producto o cualquiera de sus contenidos.
        </p>
      </Section>

      <Section title="8. Limitación de Responsabilidad" data-id="element-78">
        <p data-id="element-79">
          Los resultados descritos son orientativos y pueden variar según cada
          persona. Exosome Express no garantiza resultados específicos ni se
          hace responsable de reacciones adversas derivadas del incumplimiento
          de las instrucciones del Producto, especialmente en pieles sensibles o
          con condiciones dermatológicas previas.
        </p>
      </Section>

      <Section title="9. Ley Aplicable" data-id="element-80">
        <p data-id="element-81">
          Estos Términos se rigen por la legislación española. Para cualquier
          controversia, las partes se someten a los juzgados y tribunales del
          domicilio del consumidor, conforme a la normativa de protección al
          consumidor vigente.
        </p>
      </Section>
    </div>;
}
function Section({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <div data-id="element-82">
      <h3 className="font-playfair text-base font-bold mb-2" style={{
      color: 'var(--color-gold)'
    }} data-id="element-83">
        {title}
      </h3>
      <div className="font-lato text-sm leading-relaxed space-y-2" style={{
      color: 'rgba(253,248,240,0.7)'
    }} data-id="element-84">
        {children}
      </div>
    </div>;
}
function Li({
  children
}: {
  children: React.ReactNode;
}) {
  return <li className="flex items-start gap-2" data-id="element-85">
      <span style={{
      color: 'var(--color-gold)'
    }} className="mt-0.5 flex-shrink-0" data-id="element-86">
        ✦
      </span>
      <span data-id="element-87">{children}</span>
    </li>;
}